// src/components/layout/DashboardLayout.tsx
import React from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import WhatsAppFloat from '../WhatsAppFloat'
import { Toaster } from 'react-hot-toast'

interface DashboardLayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
  onLogout: () => void;
  onCreateOrder: () => void;
  stats: {
    bonusLevel: number;
  };
}

export default function DashboardLayout({ 
  children, 
  activeTab, 
  onTabChange, 
  onLogout, 
  onCreateOrder,
  stats 
}: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-orange-50 to-orange-100">
      {/* Sidebar */}
      <Sidebar 
        activeTab={activeTab}
        onTabChange={onTabChange}
        onLogout={onLogout}
        stats={stats}
      />

      {/* Main Content */}
      <div className="ml-64">
        {/* Header */}
        <Header 
          activeTab={activeTab}
          onCreateOrder={onCreateOrder}
        />

        {/* Page Content */}
        {/* pb-28: sağ alttaki WhatsApp float butonunun en alttaki içeriği (ör. sayfalama) kapatmaması için */}
        <main className="p-6 pb-28">
          {children}
        </main>
      </div>

      <WhatsAppFloat />
      
      {/* Toast Notifications */}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'rgba(255, 255, 255, 0.95)',
            color: '#374151',
            border: '1px solid rgba(249, 115, 22, 0.3)',
            borderRadius: '8px',
            backdropFilter: 'blur(10px)',
          },
          success: {
            iconTheme: {
              primary: '#059669',
              secondary: '#ffffff',
            },
          },
          error: {
            iconTheme: {
              primary: '#dc2626',
              secondary: '#ffffff',
            },
          },
        }}
      />
    </div>
  )
}